import { Link } from "react-router-dom";
import { seoContent, comparisonData } from "@/mocks/siteContent";

export default function SeoContent() {
  return (
    <section className="relative py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="mb-6">
          <span className="inline-block text-xs font-semibold text-foreground-400 uppercase tracking-widest mb-3">
            AllChinaBuy Spreadsheet Guide
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 max-w-3xl leading-tight mb-6">
            {seoContent.guideTitle}
          </h2>
          <p className="text-foreground-500 text-base md:text-lg max-w-2xl leading-relaxed">
            {seoContent.guideSubtitle}
          </p>
        </div>

        {/* Content Sections */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-12">
          {seoContent.sections.map((section, idx) => (
            <article key={idx} className="bg-background-100 rounded-lg p-6 md:p-8 border border-background-200/70">
              <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">
                {section.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {section.content}
              </p>
            </article>
          ))}
        </div>

        {/* Comparison Table */}
        <div className="mt-16 bg-background-100 rounded-lg border border-background-200/70 overflow-hidden">
          <div className="p-6 md:p-8 border-b border-background-200/70">
            <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
              {comparisonData.title}
            </h3>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-background-200/70">
                  <th className="text-left p-4 md:p-5 text-sm font-semibold text-foreground-700">Feature</th>
                  <th className="text-left p-4 md:p-5 text-sm font-semibold text-secondary-700">
                    <span className="flex items-center gap-2">
                      <i className="ri-checkbox-circle-fill text-secondary-500"></i>
                      AllChinaBuy Spreadsheet
                    </span>
                  </th>
                  <th className="text-left p-4 md:p-5 text-sm font-semibold text-foreground-400">
                    Regular Shopping
                  </th>
                </tr>
              </thead>
              <tbody>
                {comparisonData.rows.map((row) => (
                  <tr key={row.feature} className="border-b border-background-200/70 last:border-0">
                    <td className="p-4 md:p-5 text-sm text-foreground-700 font-medium">{row.feature}</td>
                    <td className="p-4 md:p-5 text-sm text-secondary-700">
                      <span className="flex items-center gap-2">
                        <i className="ri-check-line text-secondary-500"></i>
                        {row.spreadsheet}
                      </span>
                    </td>
                    <td className="p-4 md:p-5 text-sm text-foreground-400">{row.regular}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Internal link to article */}
        <div className="mt-12 text-center">
          <Link
            to="/best-allchinabuy-spreadsheet"
            className="inline-flex items-center gap-2 bg-primary-500 text-white text-sm md:text-base font-semibold px-8 py-3.5 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Read the Complete Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}